import type { ReactNode } from "react";

type Props = {
  eyebrow: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

/**
 * Shared header treatment for admin screens. Plum dot accent (admin),
 * eyebrow + h1 + subtitle, right-hand actions slot.
 */
export function AdminHeader({ eyebrow, title, subtitle, actions }: Props) {
  return (
    <header className="mb-6 flex items-end justify-between gap-5">
      <div>
        <div className="mb-2 flex items-center gap-2 text-eyebrow font-semibold uppercase text-fg-mute">
          <span
            aria-hidden
            className="inline-block h-1.5 w-1.5 rounded-full"
            style={{ background: "var(--admin)" }}
          />
          {eyebrow}
        </div>
        <h1 className="m-0 mb-2 text-xl font-semibold leading-tight text-fg-1">
          {title}
        </h1>
        {subtitle && (
          <p className="m-0 max-w-2xl text-sm leading-relaxed text-fg-3">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </header>
  );
}
